// ─── Avatares padrão ────────────────────────────────────────────────────────
// Fonte única no frontend para os avatares disponíveis em /public/avatares.
// Todo cliente deve ter um avatar: quando a API ainda não devolveu um (contas
// antigas ou recém-criadas), usamos um avatar padrão estável derivado de um
// identificador do usuário — assim o ícone não muda a cada renderização.

export const AVATAR_COUNT = 12;

export const AVATARS = Array.from({ length: AVATAR_COUNT }, (_, index) => {
  const num = String(index + 1).padStart(2, '0');
  return `/avatares/${num}.jpg`;
});

const hashString = (value) => {
  const text = String(value || '');
  let hash = 0;

  for (let index = 0; index < text.length; index += 1) {
    hash = (hash << 5) - hash + text.charCodeAt(index);
    hash |= 0; // mantém o hash em 32 bits
  }

  return Math.abs(hash);
};

/**
 * Retorna um avatar padrão determinístico para o usuário.
 * O mesmo usuário sempre recebe o mesmo avatar, mesmo sem avatar salvo.
 */
export const getDefaultAvatar = (seed) => {
  if (!seed) return AVATARS[0];
  return AVATARS[hashString(seed) % AVATAR_COUNT];
};

/**
 * Resolve o avatar exibido para um cliente.
 * Prioriza o avatar salvo e, na ausência dele, usa o padrão determinístico.
 */
export const resolveAvatar = (usuario) => {
  if (usuario?.avatar) return usuario.avatar;
  return getDefaultAvatar(usuario?._id || usuario?.email || usuario?.nome);
};

export const isValidAvatar = (avatar) => AVATARS.includes(avatar);
